module.exports = __webpack_public_path__ + "img/Spotify_Logo_RGB_Green.11dc437a.png";